import { render, staticRenderFns } from "./AdmissionNoteAmended.vue?vue&type=template&id=4ac9b67a&scoped=true"
import script from "./AdmissionNoteAmended.vue?vue&type=script&lang=js"
export * from "./AdmissionNoteAmended.vue?vue&type=script&lang=js"
import style0 from "./AdmissionNoteAmended.vue?vue&type=style&index=0&id=4ac9b67a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac9b67a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac9b67a')) {
      api.createRecord('4ac9b67a', component.options)
    } else {
      api.reload('4ac9b67a', component.options)
    }
    module.hot.accept("./AdmissionNoteAmended.vue?vue&type=template&id=4ac9b67a&scoped=true", function () {
      api.rerender('4ac9b67a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/AdmissionNoteAmended.vue"
export default component.exports